import { render, staticRenderFns } from "./ManageGroup.vue?vue&type=template&id=13ab5f64&scoped=true"
import script from "./ManageGroup.vue?vue&type=script&lang=js"
export * from "./ManageGroup.vue?vue&type=script&lang=js"
import style0 from "./ManageGroup.vue?vue&type=style&index=0&id=13ab5f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab5f64",
  null
  
)

export default component.exports